import { Routes, Route } from 'react-router-dom'
import Layout from './components/Layout'
import HomePage from './pages/Home'
import MenuPage from './pages/Menu'
import EventsPage from './pages/Events'
import CateringPage from './pages/Catering'
import ContactPage from './pages/Contact'

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<HomePage />} />
        <Route path="menu" element={<MenuPage />} />
        <Route path="events" element={<EventsPage />} />
        <Route path="catering" element={<CateringPage />} />
        <Route path="contact" element={<ContactPage />} />
      </Route>
    </Routes>
  )
}

